// 처리위탁 확인 문서 1건 표시 — 제목·판·(필수) + 전문 스크롤 박스 (2026-10-08, 법무검토 §2 ⑤)
//   원문은 바이트 그대로 pre-wrap. 마지막 줄 ☐ 는 해시 대상이라 그대로 둔다(실제 체크박스는 호출자가 박스 아래에 따로).
//   가입 화면·로그인 후 모달·설정 화면 공용.
import React from 'react';

function ClinicDelegationDocBox({ no, doc, required = true }) {
    return (
        <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0f172a' }}>
                {`(문서 ${no}) ${doc.title} — ${doc.version}`}
                {required && <span style={{ color: '#dc2626', fontWeight: 700 }}>{' (필수)'}</span>}
            </div>
            <div style={S.text} tabIndex={0} aria-label={`${doc.title} 전문`}>{doc.text}</div>
        </div>
    );
}

const S = {
    text: { marginTop: 6, fontSize: 12.5, color: '#1e293b', lineHeight: 1.7, whiteSpace: 'pre-wrap', wordBreak: 'keep-all', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', maxHeight: 220, overflowY: 'auto' },
};

export default ClinicDelegationDocBox;
